<template>
  <q-page class="container" padding>
    <PageHeader>
      <template #title> {{ namePage }}: #{{ ptId }} </template>
    </PageHeader>
    <div class="fit row justify-between items-start">
      <div class="row col-12 q-gutter-xs q-mt-sm q-ml-md container-inputs">
        <div class="text-brand-5 text-weight-bold col-md-2 col-sm-3 col-xs-3">
          <div class="q-ml-sm titulo-inputs">Unidade</div>
          <q-input
            class="bg-brand-7 input-responsivo"
            dense
            outlined
            v-model="pt.unidadeNome"
            disable
          />
        </div>
        <div class="text-brand-5 text-weight-bold col-md-2 col-sm-3 col-xs-3">
          <div class="q-ml-sm titulo-inputs">Nome Emissor</div>
          <q-input
            class="bg-brand-7 input-responsivo"
            dense
            outlined
            v-model="pt.emissorNome"
            disable
          />
        </div>
        <div class="text-brand-5 text-weight-bold col-md-2 col-sm-5 col-xs-5">
          <div class="q-ml-sm titulo-inputs">Status</div>
          <q-input
            dense
            outlined
            disable
            class="bg-brand-7 input-responsivo"
            v-model="statusAtual"
          >
            <template v-slot:prepend>
              <span
                v-if="pt.status == 'finalizado'"
                class="elipse q-mr-sm bg-positive"
              ></span>
              <span
                v-if="pt.status == 'cancelado'"
                class="elipse q-mr-sm"
                style="background: #707070"
              ></span>
              <span
                v-if="pt.status == 'encerrado'"
                class="elipse q-mr-sm"
                style="background: #2d3e6e"
              ></span>
              <span
                v-if="pt.status == 'iniciado'"
                class="elipse q-mr-sm"
                style="background: #6391f4"
              ></span>
              <span
                v-if="pt.status == 'aguardando_assinaturas'"
                class="elipse q-mr-sm"
                style="background: #dba700"
              ></span>
              <span
                v-if="pt.status == 'aberto'"
                class="elipse q-mr-sm"
                style="background: #b4a913"
              ></span>
            </template>
          </q-input>
        </div>
        <div class="text-brand-5 text-weight-bold col-md-2 col-sm-4 col-xs-4">
          <div class="q-ml-sm titulo-inputs">Data Inicio</div>
          <q-input
            class="bg-brand-7 input-responsivo"
            dense
            outlined
            disable
            v-model="data.inicio"
          />
        </div>
        <div class="text-brand-5 text-weight-bold col-md-2 col-sm-4 col-xs-4">
          <div class="q-ml-sm titulo-inputs">Data Término</div>
          <q-input
            class="bg-brand-7 input-responsivo"
            dense
            outlined
            disable
            v-model="data.final"
          />
        </div>
        <div class="text-brand-5 text-weight-bold col-md-2 col-sm-3 col-xs-3">
          <div class="q-ml-sm titulo-inputs">Data Emissão</div>
          <q-input
            class="bg-brand-7 input-responsivo"
            dense
            outlined
            disable
            v-model="data.emissao"
          />
        </div>
        <div class="text-brand-5 text-weight-bold col-md-2 col-sm-5 col-xs-5">
          <div class="q-ml-sm titulo-inputs">Local</div>
          <q-input
            class="bg-brand-7 input-responsivo"
            dense
            outlined
            disable
            v-model="data.local"
          />
        </div>
        <div class="text-brand-5 text-weight-bold col-md-3 col-sm-5 col-xs-5">
          <div class="q-ml-sm titulo-inputs">Descrição</div>
          <q-input
            class="bg-brand-7 input-responsivo"
            dense
            outlined
            disable
            v-model="pt.descricao"
          />
        </div>
        <div>
          <p></p>
          <router-link
            :to="{
              name: 'pdt-pt-anexos',
              params: { ptId },
            }"
          >
            <q-btn
              class="q-mt-sm btn btn-docs-mobile"
              dense
              icon="attach_file"
              no-caps
              color="primary"
              label="Documentos Enviados"
            />
          </router-link>
        </div>
        <div class="col-xl-1 col-md-2">
          <p></p>
          <q-btn
            class="q-mt-sm btn btn-imprimir-mobile"
            color="black"
            label="Imprimir"
            outline
            dense
            no-caps
            icon="print"
            @click="imprimir(ptId)"
            size="md"
          />
        </div>
      </div>
      <div class="row col-12 q-gutter-sm q-mt-lg q-ml-lg container-btn">
        <div
          v-if="
            (pt.status != 'aberto' &&
              pt.status != 'cancelado' &&
              pt.status != 'finalizado' &&
              usuarioPodeEditar) ||
            usuarioPodeRetroceder
          "
        >
          <q-btn
            color="red"
            outline
            dense
            label="Retroceder Status"
            no-caps
            icon="restore"
            class="btn"
            @click="retrocederStatus()"
          />
        </div>
        <div
          class="col-md-2"
          v-if="
            pt.status != 'finalizado' &&
            pt.status != 'cancelado' &&
            usuarioPodeEditar
          "
        >
          <q-btn
            color="positive"
            dense
            class="btn"
            :label="pt.status == 'encerrado' ? 'Finalizar PT' : 'Próxima Etapa'"
            no-caps
            icon="check_circle_outline"
            @click="proximaEtapa()"
          />
        </div>
      </div>
      <div class="row col-12 q-gutter-sm q-mt-lg q-ml-lg container-btn">
        <div v-if="pt.geolocalizacaoAtiva">
          <q-btn
            color="indigo-5"
            :outline="mapaAtivo"
            dense
            label="Localização"
            no-caps
            class="btn btn-localizacao"
            icon="location_on"
            @click="mapa()"
          />
        </div>
        <div>
          <q-btn
            color="brand-1"
            dense
            label="Responsáveis"
            no-caps
            class="btn btn-responsaveis"
            :outline="respAtivo"
            icon="person"
            @click="responsaveisPt(ptId)"
          />
        </div>
        <div>
          <q-btn
            color="brand-2"
            dense
            label="Executantes"
            no-caps
            class="btn btn-executantes"
            :outline="execuAtivo"
            icon="badge"
            @click="executantesPt(ptId)"
          />
        </div>
        <div>
          <q-btn
            color="primary"
            :outline="avaliAtivo"
            dense
            class="btn btn-avaliacao btn-avaliacao-risco"
            label="Avaliação de Risco"
            no-caps
            icon="list_alt"
            @click="avaliacaoDeRisco(ptId)"
          />
        </div>
        <div v-if="pt.status == 'encerrado' || pt.status == 'finalizado'">
          <q-btn
            color="positive"
            dense
            label="Encerramento"
            no-caps
            class="btn btn-avaliacao btn-encerramento"
            icon="assignment_turned_in"
            :outline="encerraAtivo"
            @click="encerramento(ptId)"
          />
        </div>
        <div v-if="pt.status != 'aberto'">
          <q-btn
            color="blue-grey-8"
            dense
            label="Histórico de Observações"
            no-caps
            class="btn btn-avaliacao btn-historico-observacoes"
            icon="edit_note"
            :outline="observacaoAtivo"
            @click="observacao(ptId)"
          />
        </div>
        <div>
          <q-btn
            color="blue"
            dense
            label="Histórico de Status"
            no-caps
            class="btn btn-avaliacao btn-historico-status"
            icon="autorenew"
            :outline="statusAtivo"
            @click="statusHistorico(ptId)"
          />
        </div>
      </div>
      <router-view
        v-if="mapaAtivo"
        class="q-mt-lg router-view-container"
      ></router-view>
    </div>
    <div v-if="!mapaAtivo && pt.geolocalizacaoAtiva" class="q-mt-md">
      <Map :long="pt.longitude" :lat="pt.latitude" />
    </div>
    <GeradorPdf v-if="pt" :gerarPdf="gerarPdf" :pt="pt" />

    <ScrollToTopButton />
  </q-page>
</template>

<script>
import { onMounted, ref, computed } from "@vue/runtime-core";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { useQuasar } from "quasar";

import Map from "../components/Map.vue";
import GeradorPdf from "../components/GeradorPdf.vue";
import ScrollToTopButton from "../../../../components/ScrollToTopButton.vue";
import PageHeader from "../../../../components/PageHeader.vue";

export default {
  components: {
    Map,
    GeradorPdf,
    ScrollToTopButton,
    PageHeader,
  },
  setup() {
    const route = useRoute();
    const store = useStore();
    const quasar = useQuasar();
    const router = useRouter();
    const observacaoEncerramento = ref("");
    const ptId = route.params.ptId;
    const pt = ref(false);
    const coletar = ref(false);
    const atualizar = ref(0);
    let gerarPdf = ref(0);
    const disableObs = ref(false);
    let respAtivo = ref(false);
    let execuAtivo = ref(true);
    let avaliAtivo = ref(true);
    let encerraAtivo = ref(true);
    let mapaAtivo = ref(true);
    let observacaoAtivo = ref(true);
    let statusAtivo = ref(true);
    let statusAtual = ref();
    const data = ref({
      inicio: "",
      final: "",
      emissao: "",
      local: "",
    });
    let namePage = ref("Permissão de Trabalho");

    const buscarDetalhePt = async () => {
      if (route.name == "pdt-pt-executantes") {
        execuAtivo.value = false;
        respAtivo.value = true;
        avaliAtivo.value = true;
        encerraAtivo.value = true;
        namePage.value = "Executantes";
      }
      if (route.name == "pdt-pt-responsaveis") {
        execuAtivo.value = true;
        respAtivo.value = false;
        avaliAtivo.value = true;
        encerraAtivo.value = true;
        namePage.value = "Permissão de Trabalho";
      }
      if (route.name == "pdt-pt-encerramento") {
        execuAtivo.value = true;
        respAtivo.value = true;
        avaliAtivo.value = true;
        encerraAtivo.value = false;
        namePage.value = "Questionário de Encerramento";
      }
      if (route.name == "pdt-pt-avaliacao") {
        execuAtivo.value = true;
        respAtivo.value = true;
        avaliAtivo.value = false;
        encerraAtivo.value = true;
        namePage.value = "Avaliação de Risco";
      }
      if (route.name == "pdt-pt-observacoes") {
        execuAtivo.value = true;
        respAtivo.value = true;
        avaliAtivo.value = true;
        encerraAtivo.value = true;
        observacaoAtivo.value = false;
        namePage.value = "Observações";
      }
      if (route.name == "pdt-pt-status") {
        execuAtivo.value = true;
        respAtivo.value = true;
        avaliAtivo.value = true;
        encerraAtivo.value = true;
        observacaoAtivo.value = true;
        statusAtivo.value = false;
        namePage.value = "Status";
      }
      store.dispatch("pdt/hiddenHeader", true);
      const resposta = await store.dispatch("pdt/buscarDetalhePt", { ptId });
      pt.value = resposta.data.resultado.dados;

      data.value.inicio = formatarDataHora(pt.value.dataHoraInicio);
      data.value.final = formatarDataHora(pt.value.dataHoraTermino);
      data.value.emissao = formatarDataHora(pt.value.dataHoraEmissao);

      data.value.local = pt.value.local;

      if (screen.width < 640) {
        data.value.inicio = data.value.inicio.split(" ")[0];
        data.value.final = data.value.final.split(" ")[0];
        data.value.emissao = data.value.emissao.split(" ")[0];
      }
      switch (pt.value.status) {
        case "aguardando_assinaturas":
          statusAtual.value = "Em Ass.";
          break;

        case "aberto":
          statusAtual.value = "Em Aberto";
          break;

        case "iniciado":
          statusAtual.value = "Iniciado";
          break;

        case "encerrado":
          statusAtual.value = "Encerrado";
          break;

        case "finalizado":
          statusAtual.value = "Finalizado";
          break;

        case "cancelado":
          statusAtual.value = "Cancelado";
          break;

        default:
          break;
      }

      atualizar.value++;
      if (pt.value.status == "finalizado") {
        getObsEncerramento();
      }
    };

    onMounted(buscarDetalhePt);

    const imprimir = (ptId) => {
      router.push({ name: "pdt-pt-imprimir", params: { ptId } });
    };

    const executantesPt = (ptId) => {
      execuAtivo.value = false;
      respAtivo.value = true;
      avaliAtivo.value = true;
      encerraAtivo.value = true;
      mapaAtivo.value = true;
      observacaoAtivo.value = true;
      statusAtivo.value = true;
      namePage.value = "Executantes";
      router.push({ name: "pdt-pt-executantes", params: { ptId } });
    };

    const avaliacaoDeRisco = (ptId) => {
      execuAtivo.value = true;
      respAtivo.value = true;
      avaliAtivo.value = false;
      encerraAtivo.value = true;
      mapaAtivo.value = true;
      observacaoAtivo.value = true;
      statusAtivo.value = true;
      namePage.value = "Avaliação de Risco";
      router.push({ name: "pdt-pt-avaliacao", params: { ptId } });
    };

    const encerramento = (ptId) => {
      execuAtivo.value = true;
      respAtivo.value = true;
      avaliAtivo.value = true;
      encerraAtivo.value = false;
      mapaAtivo.value = true;
      observacaoAtivo.value = true;
      statusAtivo.value = true;
      namePage.value = "Questionário de Encerramento";
      router.push({ name: "pdt-pt-encerramento", params: { ptId } });
    };

    const responsaveisPt = (ptId) => {
      execuAtivo.value = true;
      respAtivo.value = false;
      avaliAtivo.value = true;
      encerraAtivo.value = true;
      mapaAtivo.value = true;
      observacaoAtivo.value = true;
      statusAtivo.value = true;
      namePage.value = "Permissão de Trabalho";
      router.push({ name: "pdt-pt-responsaveis", params: { ptId } });
    };

    const mapa = () => {
      execuAtivo.value = true;
      respAtivo.value = true;
      avaliAtivo.value = true;
      encerraAtivo.value = true;
      mapaAtivo.value = false;
      observacaoAtivo.value = true;
      statusAtivo.value = true;
      namePage.value = "Permissão de Trabalho";
    };

    const observacao = (ptId) => {
      execuAtivo.value = true;
      respAtivo.value = true;
      avaliAtivo.value = true;
      encerraAtivo.value = true;
      mapaAtivo.value = true;
      observacaoAtivo.value = false;
      statusAtivo.value = true;
      namePage.value = "Observações";
      router.push({ name: "pdt-pt-observacoes", params: { ptId } });
    };
    const statusHistorico = (ptId) => {
      execuAtivo.value = true;
      respAtivo.value = true;
      avaliAtivo.value = true;
      encerraAtivo.value = true;
      mapaAtivo.value = true;
      observacaoAtivo.value = true;
      statusAtivo.value = false;
      namePage.value = "Status";
      router.push({ name: "pdt-pt-status", params: { ptId } });
    };

    const usuarioPodeEditar = computed(() => {
      if (!pt.value) {
        return false;
      }

      return (
        store.getters["autenticacao/usuarioLogado"].id ===
        pt.value.emissorMatricula
      );
    });

    const usuarioPodeRetroceder = computed(() => {
      if (!pt.value || !usuarioPodeEditar.value) {
        return false;
      }

      const permissoes =
        store.state.autenticacao?.usuarioLogado?.permissoes?.gmapi?.roles || [];

      switch (pt.value.status) {
        case "aguardando_assinaturas":
          return permissoes.includes("pdt-retroceder-status-em-ass");
        case "iniciado":
          return permissoes.includes("pdt-retroceder-status-iniciado");
        case "encerrado":
          return permissoes.includes("pdt-retroceder-status-encerrado");
        default:
          return false;
      }
    });

    const usuarioPodeAdicionarUser = computed(() => {
      if (!pt.value) {
        return false;
      }

      const permissoes =
        store.state.autenticacao?.usuarioLogado?.permissoes?.gmapi?.roles || [];

      switch (pt.value.status) {
        case "aguardando_assinaturas":
          return permissoes.includes("pdt-adicionar-user-em-ass");
        case "iniciado":
          return permissoes.includes("pdt-adicionar-user-iniciado");
        default:
          return true;
      }
    });

    const usuarioPodeRemoverUser = computed(() => {
      if (!pt.value) {
        return false;
      }

      const permissoes =
        store.state.autenticacao?.usuarioLogado?.permissoes?.gmapi?.roles || [];

      switch (pt.value.status) {
        case "aguardando_assinaturas":
          return permissoes.includes("pdt-remover-user-em-ass");
        case "iniciado":
          return permissoes.includes("pdt-remover-user-iniciado");
        default:
          return true;
      }
    });

    const proximaEtapa = async () => {
      const status = {
        aberto: "pdt/finalizarEdicao",
        aguardando_assinaturas: "pdt/iniciarAtividades",
        iniciado: "pdt/encerrarAtividades",
        encerrado: "pdt/finalizar",
      };

      try {
        if (pt.value.status === "encerrado") {
          await buscarDetalhePt();

          const temPermissaoValidarEncerramento =
            store.state.autenticacao?.usuarioLogado?.permissoes?.gmapi?.roles?.includes(
              "pdt-validar-encerramento"
            ) || false;

          if (!temPermissaoValidarEncerramento) {
            const temRespostaNao = pt.value.respostasEncerramento?.some(
              (pergunta) => pergunta.resposta === false
            );

            if (temRespostaNao) {
              quasar.notify({
                message:
                  "Você não tem permissão para finalizar uma PT com respostas 'Não' nos questionários.",
                color: "negative",
                actions: [
                  {
                    label: "Fechar",
                    color: "white",
                    handler: () => {
                      /* ... */
                    },
                  },
                ],
              });
              return;
            }
          }
        }

        if (
          pt.value.status == "encerrado" &&
          observacaoEncerramento.value != ""
        ) {
          await store.dispatch("pdt/observacaoEncerramento", {
            pt: pt.value.ptId,
            observacao: observacaoEncerramento.value,
          });
        }

        let resposta = await store.dispatch(status[pt.value.status], {
          ptId: pt.value.ptId,
        });

        quasar.notify({
          message: resposta.data.resultado.Mensagem,
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });

        redirecionar(ptId);
        buscarDetalhePt();
      } catch (error) {
        let mensagem = "Ocorreu um erro ao alterar status";
        if (error.response) {
          mensagem = error.response.data.erro.mensagem;
        }
        quasar.notify({
          message: mensagem,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const formatarDataHora = (valor) => {
      let hora = valor.split(" ")[1];

      let data = valor.split(" ")[0].split("-").reverse().join("/");

      return `${data} ${hora}`;
    };

    // const voltar = async () => {
    //   router.push({ name: "pdt-pt-listar" });
    // };

    const getObsEncerramento = async () => {
      disableObs.value = true;
      observacaoEncerramento.value = pt.value.obsEncerramento;
    };

    const redirecionar = (ptId) => {
      router.push({ name: "pdt-pt-detalhe", params: { ptId } });
    };

    const retrocederStatus = async () => {
      if (!usuarioPodeRetroceder.value) {
        quasar.notify({
          message: "Você não tem permissão para retroceder este status.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }

      try {
        let resposta = await store.dispatch("pdt/retrocederStatus", {
          ptId: ptId,
        });
        quasar.notify({
          message: resposta.data.resultado.Mensagem,
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        buscarDetalhePt();
        responsaveisPt(ptId);
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: error.response.data.erro.mensagem,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    return {
      ptId,
      pt,
      buscarDetalhePt,
      usuarioPodeEditar,
      usuarioPodeRetroceder,
      proximaEtapa,
      imprimir,
      observacaoEncerramento,
      coletar,
      atualizar,
      getObsEncerramento,
      disableObs,
      data,
      // voltar,
      executantesPt,
      avaliacaoDeRisco,
      encerramento,
      responsaveisPt,
      observacao,
      mapa,
      respAtivo,
      execuAtivo,
      avaliAtivo,
      encerraAtivo,
      observacaoAtivo,
      namePage,
      statusAtual,
      redirecionar,
      formatarDataHora,
      mapaAtivo,
      retrocederStatus,
      statusAtivo,
      statusHistorico,
      gerarPdf,
      usuarioPodeAdicionarUser,
      usuarioPodeRemoverUser,
      PageHeader,
    };
  },
};
</script>

<style scoped>
.elipse {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
.cursor {
  cursor: pointer;
}
a {
  text-decoration: none;
}
.router-view-container {
  margin-left: 25px;
}
.imprimir-mobile {
  display: none;
}
@media (max-width: 600px) {
  .imprimir-mobile {
    display: block;
  }
  .imprimir-desktop {
    display: none;
  }
  .container-inputs {
    margin: 0px 16px 0px 16px !important;
    gap: 8px !important;
    padding: 0px 8px !important;
  }

  /* Organização dos filtros em mobile */
  .container-inputs .text-brand-5.text-weight-bold {
    margin-bottom: 8px !important;
  }

  /* Primeira linha: Unidade e Nome Emissor */
  .container-inputs
    .text-brand-5.text-weight-bold.col-md-2.col-sm-3.col-xs-3:nth-of-type(1),
  .container-inputs
    .text-brand-5.text-weight-bold.col-md-2.col-sm-3.col-xs-3:nth-of-type(2) {
    flex: 0 0 calc(45% - 8px) !important;
    max-width: calc(45% - 8px) !important;
  }

  /* Segunda linha: Status e Data Emissão */
  .container-inputs
    .text-brand-5.text-weight-bold.col-md-2.col-sm-5.col-xs-5:nth-of-type(3),
  .container-inputs
    .text-brand-5.text-weight-bold.col-md-2.col-sm-3.col-xs-3:nth-of-type(6) {
    flex: 0 0 calc(45% - 8px) !important;
    max-width: calc(45% - 8px) !important;
  }

  /* Terceira linha: Data Início e Data Término */
  .container-inputs
    .text-brand-5.text-weight-bold.col-md-2.col-sm-4.col-xs-4:nth-of-type(4),
  .container-inputs
    .text-brand-5.text-weight-bold.col-md-2.col-sm-4.col-xs-4:nth-of-type(5) {
    flex: 0 0 calc(45% - 8px) !important;
    max-width: calc(45% - 8px) !important;
  }

  /* Quarta linha: Local sozinho */
  .container-inputs
    .text-brand-5.text-weight-bold.col-md-2.col-sm-5.col-xs-5:nth-of-type(7) {
    flex: 0 0 calc(93% - 16px) !important;
    max-width: calc(93% - 16px) !important;
  }

  /* Quinta linha: Descrição sozinha */
  .container-inputs .text-brand-5.text-weight-bold.col-md-3.col-sm-5.col-xs-5 {
    flex: 0 0 calc(93% - 16px) !important;
    max-width: calc(93% - 16px) !important;
  }

  .btn-docs-mobile {
    margin-left: 30px;
  }

  .btn-imprimir-mobile {
    margin-left: 10px;
  }

  .input-responsivo {
    font-size: 12px !important;
  }
  .elipse {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin: 0px;
    padding: 0px;
  }
  .titulo-inputs {
    font-size: 11px;
    margin: 0px 0px 4px 8px;
    font-weight: 600;
    color: #21324a;
  }
  .titulo-pagina {
    font-size: 14px;
  }
  .cursor {
    font-size: 14px !important;
    margin-top: 8px !important;
  }
  .container-btn {
    margin: 30px 0px 0px 0px;
  }
  .btn {
    font-size: 12px !important;
  }
  .btn-avaliacao {
    margin: 10px 0px 0px 0px;
  }

  .btn-avaliacao-risco,
  .btn-historico-observacoes {
    min-width: 190px !important;
    width: 190px !important;
    font-size: 12px !important;
    white-space: nowrap !important;
  }

  .btn-encerramento,
  .btn-historico-status {
    min-width: 160px !important;
    width: 160px !important;
    font-size: 12px !important;
    white-space: nowrap !important;
  }

  .btn-localizacao,
  .btn-responsaveis,
  .btn-executantes {
    min-width: 114px !important;
    width: 114px !important;
    font-size: 12px !important;
    white-space: nowrap !important;
  }

  .router-view-container {
    margin: 10px 0px 0px 0px;
  }
}
</style>
